import {Injectable} from '@angular/core';

import {PermissionService} from '../main/common/services/permission.service';

@Injectable({
    providedIn: 'root'
})
export class MenuPermission {
    menu: any;

    constructor(private _permissionService: PermissionService) {
    }

    getMenu() {
        this.menu = [
            {
                id: 'dashboard',
                title: 'Panel',
                translate: 'MENU.DASHBOARD',
                type: 'item',
                icon: '',
                newIcon: 'icon_panel',
                heightIcon: 25,
                url: 'dashboard'
            },
            {
                id: 'propietor',
                title: 'Propietarios',
                translate: 'MENU.PROPIETORS',
                type: 'item',
                icon: '',
                newIcon: 'icon_propietarios',
                heightIcon: 25,
                url: 'proprietors/index',
                hidden: !this._permissionService.checkPermission({name: 'proprietary.proprietors.read'})
            },
            {
                id: 'propertie',
                title: 'Propiedades',
                translate: 'MENU.PROPERTIES',
                type: 'item',
                icon: '',
                newIcon: 'icon_propiedades',
                heightIcon: 25,
                url: 'properties/index',
                hidden: !this._permissionService.checkPermission({name: 'property.properties.read'})
            },
            {
                id: 'tenant',
                title: 'Clientes',
                translate: 'MENU.TENANTS',
                type: 'item',
                icon: '',
                newIcon: 'icon_inquilinos',
                heightIcon: 25,
                url: 'customers/index',
                hidden: !this._permissionService.checkPermission({name: 'customer.customers.read'})
            },
            {
                id: 'lease',
                title: 'Contratos de arrendamiento',
                translate: 'MENU.LEASES',
                type: 'item',
                icon: '',
                newIcon: 'icon_arrendamientos',
                heightIcon: 25,
                url: 'contracts/index',
                hidden: !this._permissionService.checkPermission({name: 'contract.contracts.read'})
            },
            {
                id: 'annex',
                title: 'Anexos de empresa',
                translate: 'MENU.COMPANY_ANNEX',
                type: 'item',
                icon: '',
                newIcon: 'icon_annex',
                heightIcon: 25,
                url: 'company_annexes/index',
                hidden: !this._permissionService.checkPermission({name: 'contract.contracts.read'})
            },
            {
                id: 'expense',
                title: 'Gastos',
                translate: 'MENU.EXPENSES',
                type: 'item',
                icon: '',
                newIcon: 'icon_facturas',
                heightIcon: 25,
                url: 'expenses/index',
                hidden: !this._permissionService.checkPermission({name: 'contract.contracts.read'})
            },
            {
                id: 'payments',
                title: 'Pagos',
                translate: 'MENU.PAYMENTS',
                type: 'item',
                icon: '',
                newIcon: 'icon_pagos',
                heightIcon: 25,
                url: 'payments/index',
                hidden: !this._permissionService.checkPermission({name: 'contract.contracts.read'})
            },
            {
                id: 'company_invoices',
                title: 'Facturas de empresa',
                translate: 'MENU.COMPANY_ANNEX_INVOICES',
                type: 'item',
                icon: '',
                newIcon: 'icon_bill',
                heightIcon: 25,
                url: 'payments/payments-annexes',
                hidden: !this._permissionService.checkPermission({name: 'contract.contracts.read'})
            },
            {
                id: 'purchases',
                title: 'Compras',
                translate: 'MENU.PURCHASES',
                type: 'collapsible',
                icon: '',
                newIcon: 'icon_purchase',
                children: [
                    {
                        id: 'purchases-index',
                        title: 'Compras',
                        translate: 'MENU.PURCHASES',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_purchase',
                        url: 'purchases/index',
                        hidden: !this._permissionService.checkPermission({name: 'inventory.inventories.read'})
                    },
                    {
                        id: 'receptions-index',
                        title: 'Recepciones',
                        translate: 'MENU.RECEPTIONS',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_reception',
                        url: 'purchases/receptions/index',
                        hidden: !this._permissionService.checkPermission({name: 'inventory.inventories.read'})
                    }
                ]
            },
            {
                id: 'remissions-index',
                title: 'Remissions',
                translate: 'MENU.REMISSIONS',
                type: 'item',
                icon: '',
                newIcon: 'icon_remission',
                url: 'remissions/index',
                hidden: !this._permissionService.checkPermission({name: 'inventory.inventories.read'})
            },
            {
                id: 'product',
                title: 'Productos',
                translate: 'MENU.PRODUCTS',
                type: 'item',
                icon: '',
                newIcon: 'icon_product',
                heightIcon: 25,
                url: 'products/index',
                hidden: !this._permissionService.checkPermission({name: 'product.products.read'})
            },
            {
                id: 'branch',
                title: 'Sucursales',
                translate: 'MENU.BRANCHES',
                type: 'item',
                icon: '',
                newIcon: 'icon_sucursales',
                heightIcon: 25,
                url: 'branchOffices/index',
                hidden: !this._permissionService.checkPermission({name: 'common.branchOffices.read'})
            },
            {
                id: 'providers-index',
                translate: 'MENU.PROVIDERS',
                title: 'Proveedores',
                type: 'item',
                icon: '',
                newIcon: 'icon_provider2',
                heightIcon: 25,
                url: 'providers/index',
                hidden: !this._permissionService.checkPermission({name: 'provider.providers.read'})
            },
            {
                id: 'inventory',
                title: 'Inventarios',
                translate: 'MENU.INVENTORIES',
                type: 'item',
                icon: '',
                newIcon: 'icon_inventories',
                heightIcon: 25,
                url: 'inventories/index',
                hidden: !this._permissionService.checkPermission({name: 'inventory.inventories.read'})
            },
            {
                id: 'user-index',
                title: 'Usuarios',
                translate: 'MENU.USERS',
                type: 'item',
                icon: '',
                newIcon: 'icon_usuarios',
                heightIcon: 25,
                url: 'users/index',
                hidden: !this._permissionService.checkPermission({name: 'user.users.read'})
            },
            {
                id: 'role-index',
                title: 'Roles',
                translate: 'MENU.ROLES',
                type: 'item',
                icon: '',
                newIcon: 'icon_roles',
                heightIcon: 25,
                url: 'roles/index',
                hidden: !this._permissionService.checkPermission({name: 'user.roles.read'})
            },
            {
                id: 'configuration',
                title: 'Configuraciones',
                translate: 'MENU.CONFIGURATIONS',
                type: 'item',
                icon: '',
                newIcon: 'icon_configuracion',
                heightIcon: 25,
                url: 'configurations',
                hidden: !this._permissionService.checkPermission({name: 'configuration.configurations.read'})
            }
        ];

        return this.menu;
    }
}
